import { type ReactNode, useEffect } from 'react';
import { useMondayContext } from './MondayContextProvider';

/**
 * Sync monday theme to shadcn dark class and data attributes.
 */
export const MondayThemeProvider = ({ children }: { children: ReactNode }) => {
  const { context } = useMondayContext();

  useEffect(() => {
    const theme = (context as { theme?: string } | null)?.theme;
    const appearance = theme === 'dark' ? 'dark' : 'light';
    const root = document.documentElement;
    root.classList.toggle('dark', appearance === 'dark');
    root.setAttribute('data-theme', appearance);
  }, [context]);

  return <>{children}</>;
};
